import { Stack, Typography } from '@mui/material';
import { Flooding } from 'features/flooding/flooding.types';
import { UrgencyIcon } from 'features/geoEvents/components/UrgencyIcon';
import { Location } from 'features/locations/location.types';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { useTranslation } from 'react-i18next';

type UrgencyProps = {
  geoEvent: Wildfire | Flooding | Location | undefined;
};

export const Urgency = (props: UrgencyProps): JSX.Element | null => {
  const { geoEvent } = props;
  const { t } = useTranslation();

  const urgency =
    geoEvent && 'urgency' in geoEvent.data ? geoEvent.data.urgency : null;
  const isPrescribed =
    geoEvent && 'isPrescribed' in geoEvent.data && geoEvent.data.isPrescribed;

  if (!urgency || isPrescribed || !geoEvent?.reporterManaged) return null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={3}
      sx={(theme) => ({
        padding: theme.spacing(3, 2, 2),
        borderBottom: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Typography variant="h3" sx={{ fontWeight: 'fontWeightBold' }}>
        {t('geoEvent.urgency.label')}
      </Typography>
      <Stack direction="row" alignItems="center" gap={0.5}>
        <UrgencyIcon urgency={urgency} size={24} />
        <Typography>{t(`geoEvent.urgency.${urgency}`)}</Typography>
      </Stack>
    </Stack>
  );
};
